module.exports = __webpack_public_path__ + "04f58e3cdf21eebc5897a6c356b2e2fb.jpg";